import script from "./CreateLessonForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateLessonForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateLessonForm.vue?vue&type=style&index=0&id=68a5c5ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a5c5ba"]])

export default __exports__